import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const ServiceDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'service',
        routeParamKey: 'serviceId',
        pageTitle: 'Service Details',
        backRoute: '/services',
        backLabel: 'Back to Services',
        tabIdPrefix: 'service',
        tabsAriaLabel: 'service detail tabs',
        missingIdMessage: 'No service ID provided in the URL.',
        noDataMessage: 'No service data available. The service might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default ServiceDetailPage;
